import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { Section, Reveal, Placeholder } from "@/components/primitives";
import { getContent, trackEvent } from "@/lib/api";
import { LinkedinLogo, User } from "@phosphor-icons/react";

export default function Team() {
  const [team, setTeam] = useState([]);
  useEffect(() => {
    trackEvent("page_view", { page: "team" });
    getContent("team").then(setTeam).catch(() => {});
  }, []);
  return (
    <div>
      <PageHeader
        eyebrow="Team"
        title="The people building Quantum Scalp."
        sub="Verified biographies are added by administrators. We never fabricate professional histories, credentials, employment history, or achievements."
      />
      <Section grid>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="team-grid">
          {team.map((m, i) => (
            <Reveal key={m.id} delay={i * 0.06}>
              <div className="qs-beam h-full rounded-xl border border-white/10 bg-[#0A0B10] p-6">
                <div className="aspect-square rounded-lg border border-white/10 bg-white/[0.02] grid place-items-center overflow-hidden mb-5">
                  {m.photo ? (
                    <img src={m.photo} alt={m.name} loading="lazy" className="h-full w-full object-cover" />
                  ) : (
                    <User size={48} className="text-[#334155]" weight="duotone" />
                  )}
                </div>
                <h3 className="text-base font-bold text-white">{m.name}</h3>
                <p className="text-sm text-[#2DD4BF] mt-0.5">{m.position}</p>
                <p className="text-sm text-[#94A3B8] mt-3 leading-relaxed">
                  {m.bio?.startsWith("[") ? <Placeholder>{m.bio}</Placeholder> : m.bio}
                </p>
                {m.responsibilities && <p className="text-xs text-[#64748B] mt-3">{m.responsibilities}</p>}
                {m.linkedin && (
                  <a href={m.linkedin} className="mt-4 inline-flex items-center gap-1.5 text-sm text-[#94A3B8] hover:text-[#2DD4BF] transition-colors">
                    <LinkedinLogo size={16} /> Profile
                  </a>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
    </div>
  );
}
